module.exports = function() {
  return new Worker(__webpack_public_path__ + "0f77bc160295a1813e84.worker.js");
};